import React from 'react';
import ContentContainer from '@shared/ui/Containers/ContentContainer';
import { useRecoilValue } from 'recoil';
import { ISiteContentPage } from './types';
import {
  CustomerSiteLogo,
  CustomerMenuWrapper,
  CustomerPageTitle,
  CustomerMenuTitle,
} from './styledComponents';
import { currentPageTitleAtom } from '../shared/state/orderState';
import { currentCustomerAtom } from '../shared/state/customerState';
import { usePermissions } from '@shared/permissions/usePermissions';

const ContentWrapper = ({ children }: ISiteContentPage) => {
  const currentCustomer = useRecoilValue(currentCustomerAtom);
  const currentPageTitle = useRecoilValue(currentPageTitleAtom);
  const { hasPermission } = usePermissions();
  const isCustomerUser = !hasPermission('customers.pricing');

  return (
    <>
      <ContentContainer>
        {isCustomerUser && (
          <CustomerMenuWrapper>
            <CustomerSiteLogo />
            <CustomerMenuTitle>{currentCustomer?.CompanyName ?? ''}</CustomerMenuTitle>
            {!!currentPageTitle.length && (
              <CustomerPageTitle>{currentPageTitle}</CustomerPageTitle>
            )}
          </CustomerMenuWrapper>
        )}
        { children }
      </ContentContainer>
    </>
  );
};

export default ContentWrapper;
